import React from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';
import { IconExternalLink } from '@tabler/icons-react';
import { appendReferralParams } from '../../../shared/utility';
import { renderMarkdownToReact } from '../../../components/UI/MarkdownText/MarkdownText';
import styles from './FactModal.module.scss';

function SparkleDecor() {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            stroke="#f5a623"
            strokeWidth="2.67"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M5.33 6.67H8" />
            <path d="M6.67 5.33V8" />
            <path d="M15.33 5.33L14.67 8" />
            <path d="M24 6.67H26.67" />
            <path d="M25.33 5.33V8" />
            <path d="M20 12L18.67 13.33" />
            <path d="M24 17.33L26.67 16.67" />
            <path d="M24 25.33H26.67" />
            <path d="M25.33 24V26.67" />
            <path d="M8 16a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z" />
        </svg>
    );
}

const FactModal = ({ factData, onClose, backdropClassName }) => {
    if (!factData) return null;

    const fact = factData.fact;
    const hasLink = fact?.linkUrl && fact.linkUrl !== '#';
    const destinationUrl = hasLink ? appendReferralParams(fact.linkUrl) : null;
    const isExternal =
        destinationUrl && (destinationUrl.startsWith('http://') || destinationUrl.startsWith('https://'));

    return (
        <Modal
            isOpen={!!factData}
            toggle={onClose}
            centered
            className="mx-auto"
            contentClassName="border-0 shadow-lg"
            backdropClassName={backdropClassName}
            style={{ maxWidth: '360px' }}
        >
            <ModalBody className="text-center p-4 d-flex flex-column align-items-center gap-3 bg-white text-dark rounded-3">
                <div className="d-flex align-items-center justify-content-center my-1">
                    <SparkleDecor />
                </div>

                <div className="w-100">
                    <h2 className="h5 text-dark mb-2 fw-bold">{fact?.headline || 'Gut gemacht!'}</h2>
                    {fact?.copy && <p className="small text-secondary mb-0 text-center" style={{ fontSize: '14px', lineHeight: '1.4' }}>{renderMarkdownToReact(fact.copy)}</p>}
                </div>

                {fact?.imageUrl && (
                    <div className={`${styles.imageContainer} w-100 rounded-3 overflow-hidden my-1 d-flex align-items-center justify-content-center`}>
                        <img src={fact.imageUrl} alt={fact?.headline || 'Fakt Bild'} className="w-100 h-100 object-fit-cover" />
                    </div>
                )}

                {hasLink ? (
                    <>
                        <Button
                            href={destinationUrl}
                            tag="a"
                            target="_blank"
                            rel="noopener"
                            color="yellow"
                            className="w-100 fw-bold border-0 text-dark py-2"
                            style={{ borderRadius: '8px', fontSize: '16px' }}
                        >
                            <span className="d-flex align-items-center justify-content-center gap-1">
                                {fact?.buttonText || 'Mehr erfahren'}
                                {isExternal && <IconExternalLink size={16} />}
                            </span>
                        </Button>
                        <Button
                            type="button"
                            onClick={onClose}
                            color="dark"
                            outline
                            className="w-100 mt-1 fw-semibold py-2"
                            style={{ borderRadius: '8px', fontSize: '14px' }}
                        >
                            Weiterspielen
                        </Button>
                    </>
                ) : (
                    <Button
                        type="button"
                        onClick={onClose}
                        color="yellow"
                        className="w-100 fw-bold border-0 text-dark py-2"
                        style={{ borderRadius: '8px', fontSize: '16px' }}
                    >
                        <span className="d-flex align-items-center justify-content-center gap-1">
                            {fact?.buttonText || 'Weiter'}
                        </span>
                    </Button>
                )}
            </ModalBody>
        </Modal>
    );
};

export default FactModal;
